// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollGroupReducedDto
 */
export interface IPayrollGroupReducedDto {
    /**
     * 
     * @type {number}
     * @memberof IPayrollGroupReducedDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollGroupReducedDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollGroupReducedDto
     */
    code?: string;
}

/**
 * Check if a given object implements the IPayrollGroupReducedDto interface.
 */
export function instanceOfIPayrollGroupReducedDto(value: object): value is IPayrollGroupReducedDto {
    return true;
}

export function IPayrollGroupReducedDtoFromJSON(json: any): IPayrollGroupReducedDto {
    return IPayrollGroupReducedDtoFromJSONTyped(json, false);
}

export function IPayrollGroupReducedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollGroupReducedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
    };
}

export function IPayrollGroupReducedDtoToJSON(json: any): IPayrollGroupReducedDto {
    return IPayrollGroupReducedDtoToJSONTyped(json, false);
}

export function IPayrollGroupReducedDtoToJSONTyped(value?: IPayrollGroupReducedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
    };
}

